/**
 * Financial Document Components - Barrel Export
 * PROMPT 40: Financial Documents Unified View Layer
 * PROMPT 41: Financial Communications
 * EF-QUOTE-DETAIL-ALIGN-01: Grouped Line Items
 */
export { DocumentHeader } from "./DocumentHeader";
export { DocumentDetails } from "./DocumentDetails";
export { LineItemsTable } from "./LineItemsTable";
export { GroupedLineItems } from "./GroupedLineItems";
export { TotalsSummary } from "./TotalsSummary";
export { DocumentFooter } from "./DocumentFooter";
export { DocumentActions } from "./DocumentActions";
export { EmailComposeModal } from "./EmailComposeModal";
export { EmailLogSection } from "./EmailLogSection";

// Print styles for financial documents
export const printStyles = `
  @media print {
    body {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    
    /* Hide navigation and other non-print elements */
    .print\\:hidden {
      display: none !important;
    }
    
    /* Reset backgrounds for print */
    .print\\:bg-white {
      background-color: white !important;
    }
    
    .print\\:text-slate-900 {
      color: #0f172a !important;
    }
    
    .print\\:text-slate-600 {
      color: #475569 !important;
    }
    
    .print\\:text-teal-600 {
      color: #0d9488 !important;
    }
    
    .print\\:shadow-none {
      box-shadow: none !important;
    }
    
    .print\\:rounded-none {
      border-radius: 0 !important;
    }
    
    .print\\:border-b-2 {
      border-bottom-width: 2px !important;
    }
    
    .print\\:border-slate-200 {
      border-color: #e2e8f0 !important;
    }
    
    /* Ensure proper page breaks */
    table {
      page-break-inside: avoid;
    }
    
    tr {
      page-break-inside: avoid;
    }
  }
`;
